/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Done_BadgeInputs */



/**
* | output |
* | --- |
* | "Done" |
*
* @param {Compare_Event_Groups_Done_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_done_badge = /** @type {((inputs?: Compare_Event_Groups_Done_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Done_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fait")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erledigt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fatto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сделанный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Hecho")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("完毕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("終わり")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Feito")
	return /** @type {LocalizedString} */ ("Done")
});